import resume from '../assets/pdf/SALONI_RESUME.pdf'
import img1 from '../assets/profile/img1.png'


export const headerData = {
    name: 'Saloni Tomar',
    title: "Full Stack Developer & Data Enthusiast",
    desciption:"Hey 👋, I'm Saloni Tomar, a passionate tech enthusiast and aspiring Full Stack Developer. I believe that discipline turns ambitions into achievements and ideas into reality.",
    image: img1,
    resumePdf: resume
}
